// import React, { useEffect, useState } from "react";
// import { Modal } from "react-bootstrap";
// import { useForm } from "react-hook-form";
// import { zodResolver } from "@hookform/resolvers/zod";
// import { AddOfferModolSchema } from "../../../lib/zodForValidation";
// import axios from "axios";
// import { TextField } from "@mui/material";
// import { useSelector } from "react-redux";
// import { GET_DOOR_STEP_SUB_CATEGORY, SERVICES_OFFERS } from "../../../URLs/Apis";
// import AddIcon from "../../../assets/images/AddIcon.svg";
// import { useLocation } from "react-router-dom";
// import PenForEdit from "../../../assets/svg/PenForEdit.svg";
// import trash from "../../../assets/svg/trash.svg";
// import noDataFound from "../../../assets/images/noDataFound.jpg";
// import PictureComp from "../../../components/pictureComp";
// import CameraIcon from "../../../assets/svg/CameraIcon.svg"
// import { toast } from "react-toastify";
// function OffersPage() {
//   const location = useLocation();
//   const queryParams = new URLSearchParams(location.search);
//   const eId = queryParams.get("eid");

//   const { user } = useSelector((state) => state.auth);
//   const headers = {
//     Authorization: "Bearer " + user?.token,
//   };

//   // ADD OFFER
//   const [addOfferModel, setAddOfferModel] = useState(false);
//   const [offerData, setOfferData] = useState([])
//   const [offerImage,setOfferImage]= useState("")
//   const [addOfferdata, setAddOfferdata] = useState({
//     door_step_service_category_id: "",
//     name: "",
//     description: "",
//     image:""
//   });
//   const [servicesToSelectOffer, setServicesToSelectOffer] = useState(null);
//   const [arrOfOfferSrveices, setArrOfOfferSrveices] = useState([]);
//   const showOfferModol = (e) => {
//     setAddOfferModel(true);
//     axios
//       .get(GET_DOOR_STEP_SUB_CATEGORY + "/" + e, {
//         headers,
//       })
//       .then((response) => {
//         setServicesToSelectOffer(response.data.data.service_category);
//       })
//       .catch((error) => {
//         console.log(error.data);
//       });

//     setAddOfferdata({
//       ...addOfferdata,
//       door_step_service_category_id: e,
//     });
//   };
//   const CloseOfferModol = () => {
//     setAddOfferModel(false);
//     setAddOfferdata({
//       door_step_service_category_id: "",
//       name: "",
//       description: "",
//       image: "",
//     });
//     setArrOfOfferSrveices([]);
//     reset();
//   };
//   const appendOfferData = (data) => {
//     const formData = new FormData()
//     formData.append("door_step_service_category_id", data.door_step_service_category_id)
//     formData.append("name", data.name)
//     formData.append("description", data.description)
//     Object.entries(data.services).forEach(([key, value]) => {

//       formData.append(`services[${key}]`, value);
//     });
//     if (data.image instanceof File) {
//       console.log(data.image instanceof File);

//       formData.append("image", data.image);
//     }

//     return formData;

//   }
//   const onSubmitAddOfer = async (data) => {
//     const AddOfferResult = {
//       ...data,
//       door_step_service_category_id: addOfferdata.door_step_service_category_id,
//       services: arrOfOfferSrveices,
//       image: addOfferdata.image,
//     };
//     const offerData = appendOfferData(AddOfferResult)
// // console.log(AddOfferResult);


//     try {
//       const response = await axios.post(SERVICES_OFFERS,

//         offerData
//         , {
//           headers
//         })
//       console.log(offerData);
//       toast.success(response.data.data.message)
//       setAddOfferdata({
//         door_step_service_category_id: "",
//         name: "",
//         description: "",
//         image: "",
//       });
//       setArrOfOfferSrveices([]);
//       setAddOfferModel(false);
//       reset();
//     } catch (error) {
//       console.log(error);
//       toast.error(error.response.data.message)

//     }

//   };

//   const {
//     register: registerAddOfferModol,
//     handleSubmit: handleSubmitRH,
//     formState: { errors: errorsOfferModol },
//     reset,
//   } = useForm({
//     resolver: zodResolver(AddOfferModolSchema),
//   });
//   const getOffer = async () => {
//     try {
//       let response = await axios.get(
//         `${SERVICES_OFFERS}?category_id=${eId} `,
//         {
//           headers,
//         }
//       );
//       setOfferData(response?.data?.data?.offers);
//     } catch (error) {
//       console.log(error.message);
//     }
//   }
//   const FileChange = (e)=>{
//     const file = e.target.files[0];

//     if (file) {
//       const reader = new FileReader();

//       reader.onloadend = () => {
//         setAddOfferdata((prevData) => ({
//           ...prevData,
//           image: file,
//         }));
//         setOfferImage(reader.result);
//       };

//       reader.readAsDataURL(file);
//     }
//   }
//   useEffect(() => {
//     getOffer();

//   }, [arrOfOfferSrveices]);
//   return (
//     <>
//       <Modal show={addOfferModel} onHide={CloseOfferModol}>
//         <Modal.Header className="AddStaffModal_header">
//           <Modal.Title className="AddStaffModal_title">Add Offer</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <form onSubmit={handleSubmitRH(onSubmitAddOfer)}>
//             <TextField
//               className="w-100 mb-4"
//               label="Offer Name"
//               variant="outlined"
//               {...registerAddOfferModol("name")}
//               error={!!errorsOfferModol.name}
//               helperText={errorsOfferModol.name?.message}
//             />
//             <TextField
//               className="w-100 mb-4"
//               label="Description"
//               variant="outlined"
//               rows={4}
//               multiline
//               {...registerAddOfferModol("description")}
//               error={!!errorsOfferModol.description}
//               helperText={errorsOfferModol.description?.message}
//             />

//             {servicesToSelectOffer?.map((j) => {
//               return (
//                 <>
//                   {arrOfOfferSrveices[j.id] &&
//                     Number(arrOfOfferSrveices[j.id]) > Number(j.price) && (
//                       <p className="danger">
//                         The Offer Price must be lower than the Current Price of
//                         '{j.name}''
//                       </p>
//                     )}
//                   <div className="subCategoryServese" key={j.id}>
//                     <div className="leftSide_subCategoryServese">{j.name}</div>
//                     <div className="rightSide_subCategoryServese">
//                       {j.price}
//                       <TextField
//                         style={{ width: "85px", important: "true" }}
//                         label="Offer Price"
//                         variant="outlined"
//                         type="number"
//                         value={arrOfOfferSrveices[j.id] || ""}
//                         onChange={(e) => {
//                           const offerPrice = e.target.value;

//                           if (/^\d*$/.test(offerPrice)) {
//                             setArrOfOfferSrveices((prevData) => ({
//                               ...prevData,
//                               [j.id]: offerPrice,
//                             }));
//                           }
//                         }}
//                       />
//                     </div>
//                   </div>
//                 </>
//               );
//             })}
//             <div className="  my-3">
//               <h6 className="greyFont">Upload offer Image:</h6>
//               <div className="d-flex align-items-center justify-content-center"> <label htmlFor="offer-img" className=" w-50">                  {addOfferdata.image ? (
//                         offerImage && (
//                           <img
//                             className="photoStyle_ins"
//                             src={offerImage}
//                             alt="Preview"
//                           />
//                         )
//                       ) : (
//                         <div className="offer-img-box   d-flex align-items-center justify-content-center">
//                         <img  src={CameraIcon}/>
//                       </div>
//                       )}
//               </label>
//                 <input id="offer-img" className="d-none" type="file" onChange={(e)=>FileChange(e)}/></div>

//             </div>
//             <div className="foterAddModel">
//               <button
//                 type="button"
//                 className="closAddModal"
//                 onClick={CloseOfferModol}
//               >
//                 Cancel
//               </button>
//               <button
//                 type="submit"
//                 disabled={Object.entries(arrOfOfferSrveices).every(
//                   ([id, value]) => {
//                     const service = servicesToSelectOffer.find(
//                       (s) => s.id === Number(id)
//                     );
//                     return (
//                       !value ||
//                       value.trim() === "" ||
//                       Number(value) > (service?.price || Infinity)
//                     );
//                   }
//                 )}
//                 className="saveAddModeal"
//               >
//                 Save
//               </button>
//             </div>

//           </form>
//         </Modal.Body>
//       </Modal>
//       <div className="titleOfServicesPage">
//         <div className="titleOfServicesPage_title">Offers</div>
//         <div
//           className="staff-header_edete-icon mainBorder d-flex "
//           onClick={() => showOfferModol(eId)}
//         >
//           <img src={AddIcon} alt="" />
//           <span className="ms-1 d-flex">Add New Offer</span>
//         </div>
//       </div>
//       {/* {fakeData.length > 0 ? (
//         <div className="mainCategoryCards">
//           {fakeData.map((e) => {
//             return (
//               <>
//                 <div key={e.id} className="services_card NOcursor">
//                   <div className="mianCategory_title">{e?.name}</div>
//                   <div className="mianCategory_descrebtion mb-4">
//                     {e?.description}
//                   </div>
//                   <ul>
//                     {e.servicesOffer.map((service) => (
//                       <li key={service.id} className="servicesOfferStyling">
//                         <div className="">The Service ID: {service.id} </div>
//                         <div className="">The Offer: {service.offerPrice}</div>
//                       </li>
//                     ))}
//                   </ul>
//                   <div className="edateTheOffercarde">
//                     <div className="iconContuiner">
//                       <img src={PenForEdit} alt="" />
//                     </div>
//                     <div className="iconContuiner">
//                       <img src={trash} alt="" />
//                     </div>
//                   </div>
//                 </div>
//               </>
//             );
//           })}
//         </div>
//       ) : (
//         <div className="noStaff-cards">
//           <img
//             className="noStaffImg"
//             src={noDataFound}
//             alt="No staff members"
//           />
//           <p className="noDataStaff-masege">
//             No Offer have been added yet. Click add to new Offer.
//           </p>
//         </div>
//       )} */}
//       <div className="container">
//         <div className="row g-4">
//           {offerData.length > 0 ? (
//             offerData.map((offer) => (
//               <>
//                 <div className="col-3">
//                   <div
//                     key={offer.id}
//                     style={{ height: "425px", overflow: "auto" }}
//                     className="d-flex flex-column align-items-center justify-content-center border border-1 rounded-4 offer_card"
//                   >
//                     <div className="mianCategory_title">{offer.name}</div>
//                     <div className="d-flex align-items-center">
//                       <p style={{ textDecorationLine: "line-through" }}>
//                         {offer.total_price}
//                       </p>
//                       <p className="mx-2">بدلا من</p>
//                       <p>{offer.offer_price}</p>
//                     </div>
//                     <div className="mb-4 mianCategory_descrebtion">
//                       {offer.description}
//                     </div>
//                     <ul>
//                       {offer.services.map((ser) => (
//                         <li key={ser.id} className="servicesOfferStyling">
//                           <div className=""> {ser.name} </div>
//                         </li>
//                       ))}
//                     </ul>
//                     <div className="d-flex justify-content-evenly w-50 edateTheOffercarde mx-auto">
//                       <div className="iconContuiner">
//                         <img src={PenForEdit} alt="" />
//                       </div>
//                       <div className="iconContuiner">
//                         <img src={trash} alt="" />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </>
//             ))
//           ) : (
//             <div className="noStaff-cards">
//               <img
//                 className="noStaffImg"
//                 src={noDataFound}
//                 alt="No staff members"
//               />
//               <p className="noDataStaff-masege">
//                 No Offer have been added yet. Click add to new Offer.
//               </p>
//             </div>
//           )}
//         </div>
//       </div>
//     </>
//   );
// }

// export default OffersPage;

// //   { id: 1, offerPrice: 22 },
// // [
// //   { id: 2, offerPrice: 30 },
// // ];
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { AddOfferModolSchema } from "../../../lib/zodForValidation";
import axios from "axios";
import { TextField } from "@mui/material";
import { useSelector } from "react-redux";
import { GET_DOOR_STEP_SUB_CATEGORY, SERVICES_OFFERS } from "../../../URLs/Apis";
import AddIcon from "../../../assets/images/AddIcon.svg";
import { useLocation } from "react-router-dom";
import PenForEdit from "../../../assets/svg/PenForEdit.svg";
import trash from "../../../assets/svg/trash.svg";
import noDataFound from "../../../assets/images/noDataFound.jpg";
import DeleteModal from "../../../components/Modals/DeleteModal";
import { toast } from "react-toastify";
import CameraIcon from "../../../assets/svg/CameraIcon.svg";

function OffersPage() {

  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);

  const eId = queryParams.get("eid");

  const [isEditing, setIsEditing] = useState(false);
  const [isRemoveOffer, setIsRemoveOffer] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);

  const [offerId, setOfferId] = useState("");
  const [serviceOfferId, setServiceOfferId] = useState("");

  const [showDelete, setShowDelete] = useState(false);

  const [offerImage, setOfferImage] = useState("");

  const handleDeleteShow = (id,serviceId) => {
    setOfferId(id);
    setServiceOfferId(serviceId)
    console.log("idddddd",id,serviceId);
    
    setShowDelete(true);
  };

  const handleDeleteClose = () => {
    setShowDelete(false);
    if(isRemoveOffer){
      setIsRemoveOffer(false)
    }
  };

  const [updateId, setUpdateId] = useState(null)

  const handleUpdateOffer = async (id, name, description) => {
    setIsEditing(true);
    showOfferModol(eId);
    setUpdateId(id);
    getSpecificOffer(id);
    setValue("name", name);
    setValue("description", description);
  };

  const { user } = useSelector((state) => state.auth);
 
  const headers = {
    Authorization: "Bearer " + user?.token,
  };

  const [addOfferModel, setAddOfferModel] = useState(false);

  const [addOfferdata, setAddOfferdata] = useState({
    door_step_service_category_id: "",
    name: "",
    description: "",
    image: "",
  });

  const [offerData, setOfferData] = useState([]);

  const [specificOffer, setSpecificOffer] = useState(null);

  const [servicesToSelectOffer, setServicesToSelectOffer] = useState(null);

  const [arrOfOfferSrveices, setArrOfOfferSrveices] = useState([]);

  const showOfferModol = (e) => {
    setAddOfferModel(true);
    axios
      .get(GET_DOOR_STEP_SUB_CATEGORY + "/" + e, {
        headers,
      })
      .then((response) => { 
        setServicesToSelectOffer(response.data.data.service_category);
      })
      .catch((error) => {
        console.log(error.data);
      });
    setAddOfferdata({
      ...addOfferdata,
      door_step_service_category_id: e,
    });
  };

  const CloseOfferModol = () => {
    setAddOfferModel(false);
    setAddOfferdata({
      door_step_service_category_id: "",
      name: "",
      description: "",
      image: "",
    });
    setArrOfOfferSrveices([]);
    reset();
  };

  const appendOfferData = (data) => {
    const formData = new FormData();
    formData.append(
      "door_step_service_category_id",
      data.door_step_service_category_id
    );
    formData.append("name", data.name);
    formData.append("description", data.description);
    Object.entries(data.services).forEach(([key, value]) => {
      formData.append(`services[${key}]`, value);
    });
    if (data.image instanceof File) {
      console.log(data.image instanceof File);

      formData.append("image", data.image);
    }
    return formData;
  };

  const appendOfferUpdateData = (data) => {
    const formData = new FormData();
    formData.append("name", data.name);
    formData.append("description", data.description);
    formData.append("_method", "PATCH");
    formData.append('status', 'active');
    Object.entries(data.services).forEach(([key, value]) => {
      formData.append(`services[${key}]`, value);
    });
    if (data.image instanceof File) {
      console.log(data.image instanceof File);

      formData.append("image", data.image);
    }
    return formData;
  };

  const onSubmitAddOffer = async (data) => {
    const AddOfferResult = {
      ...data,
      door_step_service_category_id: addOfferdata.door_step_service_category_id,
      services: arrOfOfferSrveices,
      image: addOfferdata.image,
    };
    const updateOfferResult = {
      ...data,
      services: arrOfOfferSrveices,
      image: addOfferdata.image,
    };
    const offerData = appendOfferData(AddOfferResult);
    const UpdateData = appendOfferUpdateData(updateOfferResult);
    console.log(AddOfferResult);
    console.log(UpdateData);
    try {
      let response;
      if (isEditing) {
        response = await axios.post(
          `https://estbn.com/MobileAppBackend/public/api/door_step_offers/${updateId}`,
          UpdateData,
          {
            headers,
          }
        );
        toast.success('Offer Updated Succeddfully', { autoClose: 3000 });
      } else {
        response = await axios.post(
          "https://estbn.com/MobileAppBackend/public/api/door_step_offers",
          offerData,
          {
            headers,
          }
        );
        toast.success('Offer Created Successfully', { autoClose: 3000 });
      }
      console.log(response);
      getOffers();
      setAddOfferdata({
        door_step_service_category_id: "",
        name: "",
        description: "",
      });
      setArrOfOfferSrveices([]);
      setAddOfferModel(false);
      reset();
    } catch (error) {
      console.log(error.message);
      toast.error(error.message);
    }
  };

  const FileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        setAddOfferdata((prevData) => ({
          ...prevData,
          image: file,
        }));
        setOfferImage(reader.result);
      };

      reader.readAsDataURL(file);
    }
  };

const handleRemoveServiceFromOffer = async ()=>{

  try {
    const response = await axios.post("https://estbn.com/MobileAppBackend/public/api/remove_service_from_offer",{
      offer_id:offerId,
      service_id:serviceOfferId

    },{headers})
    console.log(response);
    toast.success(response.data.data.message)
    setIsDeleted(true)
    handleDeleteClose()
    getOffers()
   
    
  } catch (error) {
    console.log(error);
    toast.error(error.response.errors.data.message)
  }
}

  const {
    register: registerAddOfferModol,
    handleSubmit: handleSubmitRH,
    formState: { errors: errorsOfferModol },
    reset,
    setValue,
  } = useForm({
    resolver: zodResolver(AddOfferModolSchema),
  });

  const getOffers = async () => {
    try {
      let response = await axios.get(
        `https://estbn.com/MobileAppBackend/public/api/door_step_offers?category_id=${eId} `,
        {
          headers,
        }
      );
      console.log(response.data.data?.offers);
      setOfferData(response?.data?.data?.offers);
    } catch (error) {
      console.log(error.message);
    }
  };

  const getSpecificOffer = async (id) => {
    try {
      let response = await axios.get(
        `https://estbn.com/MobileAppBackend/public/api/door_step_offers/${id}`,
        {
          headers,
        }
      );
      console.log(response.data.data.offer);
      setSpecificOffer(response.data.data?.offer);
    } catch (error) {
      console.log(error.message);
    }
  };

  const deleteOffer = async () => {
    try {
      let response = await axios.delete(
        `https://estbn.com/MobileAppBackend/public/api/door_step_offers/${offerId}`,
        { headers }
      );
      console.log(response);
      getOffers();
      handleDeleteClose();
      toast.info(response.data.data.message, { autoClose: 3000 });
    } catch (error) {
      console.log(error.message);
      toast.error(error.message);
    }
  };

  useEffect(() => {
    getOffers();
  }, []);

  useEffect(() => {
    if (specificOffer) {
      const updatedPrices = {};
      specificOffer.services.forEach((service) => {
        if (service.selected) {
          updatedPrices[service.id] = service.offer_price;
        }
      });
      setArrOfOfferSrveices(updatedPrices);
      const imageProperty = specificOffer.control_type?.properties?.find(
        (prop) => prop.name === "icon_url" && prop.type === "image"
      );
      const imageUrl = imageProperty
        ? "https://estbn.com/MobileAppBackend/public/" + imageProperty.value
        : "";

      setAddOfferdata({
        door_step_service_category_id:
          specificOffer.door_step_service_category_id,
        name: specificOffer.name,
        description: specificOffer.description,
        image: imageUrl,
      });

      setOfferImage(imageUrl);
    }
  }, [specificOffer]);

  return (
    <div >
      {/* Delete Modal  */}
      <DeleteModal
        showDelete={showDelete}
        handleDeleteClose={handleDeleteClose}
        textMessage={
          "Are you sure you want to delete this offer ? Confirm to proceed or cancel to keep them."
        }
        deleteFunction={isRemoveOffer? handleRemoveServiceFromOffer : deleteOffer}

      />
      {/* Create Modal */}
      <Modal show={addOfferModel} onHide={CloseOfferModol}>
        <Modal.Header className="AddStaffModal_header">
          <Modal.Title className="AddStaffModal_title">
            {isEditing ? "Update Offer" : "Add Offer"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmitRH(onSubmitAddOffer)}>
            <TextField
              className="w-100 mb-4"
              label="Offer Name"
              variant="outlined"
              {...registerAddOfferModol("name")}
              error={!!errorsOfferModol.name}
              helperText={errorsOfferModol.name?.message}
            // defaultValue={isEditing?updateOfferdata.name:""}
            />
            <TextField
              className="w-100 mb-4"
              label="Description"
              variant="outlined"
              rows={4}
              multiline
              {...registerAddOfferModol("description")}
              error={!!errorsOfferModol.description}
              helperText={errorsOfferModol.description?.message}
            // defaultValue={isEditing?updateOfferdata.description:""}
            />
            {servicesToSelectOffer?.map((j) => {
              const selectedService = isEditing
                ? specificOffer?.services.find(
                  (service) => service.id === j.id && service.selected
                )
                : null;

              const currentOfferPrice = selectedService
                ? arrOfOfferSrveices[j.id] || selectedService.offer_price
                : arrOfOfferSrveices[j.id] || "";
              return (
                <>
                  {arrOfOfferSrveices[j.id] &&
                    Number(arrOfOfferSrveices[j.id]) >= Number(j.price) && (
                      <p className="danger">
                        The Offer Price must be lower than the Current Price of
                        '{j.name}'
                      </p>
                    )}
                  <div className="subCategoryServese " key={j.id}>
                    <div className="leftSide_subCategoryServese d-flex gap-1 align-items-center ">





                      <div>{j.name}</div>
                      {selectedService ? <img onClick={()=>{handleDeleteShow(specificOffer.id,j.id)
                        setIsRemoveOffer(true)
                      }} src={trash} alt="" /> : null
                      }

                    </div>
                    <div className="rightSide_subCategoryServese">
                      {j.price}
                      <TextField
                        style={{ width: "85px", important: "true" }}
                        label="Offer Price"
                        variant="outlined"
                        type="number"
                        value={currentOfferPrice}
                        onChange={(e) => {
                          const offerPrice = e.target.value;
                          if (/^\d*$/.test(offerPrice)) {
                            setArrOfOfferSrveices((prevData) => ({
                              ...prevData,
                              [j.id]: offerPrice,
                            }));
                          }
                        }}
                      />
                    </div>
                  </div>
                </>
              );
            })}
            <div className="my-3">
              <h6 className="greyFont">Upload offer Image:</h6>
              <div className="d-flex align-items-center justify-content-center">
                <label htmlFor="offer-img" className="w-50">
                  {addOfferdata.image ? (
                    typeof addOfferdata.image === "string" ? (
                      <img
                        className="w-100"
                        src={addOfferdata.image}
                        alt="Preview"
                      />
                    ) : (
                      offerImage && (
                        <img className="w-100" src={offerImage} alt="Preview" />
                      )
                    )
                  ) : (
                    <div className="offer-img-box mx-auto d-flex align-items-center justify-content-center">
                      <img src={CameraIcon} alt="" />
                    </div>
                  )}
                </label>
                <input
                  id="offer-img"
                  className="d-none"
                  type="file"
                  onChange={FileChange}
                />
              </div>
            </div>
            <div className="foterAddModel">
              <button
                type="button"
                className="closAddModal"
                onClick={CloseOfferModol}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={Object.entries(arrOfOfferSrveices).every(
                  ([id, value]) => {
                    const service = servicesToSelectOffer?.find(
                      (s) => s.id === Number(id)
                    );
                    return (
                      !value ||
                      value.trim() === "" ||
                      Number(value) > (service?.price || Infinity)
                    );
                  }
                )}
                className="saveAddModeal"
              >
                Save
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      {/* Title Of Offers  */}
      <div className="titleOfServicesPage m-4">
        <div className="titleOfServicesPage_title">Offers</div>
        <div
          className="d-flex mainBorder staff-header_edete-icon"
          onClick={() => {
            showOfferModol(eId);
            setIsEditing(false);
          }}
        >
          <img src={AddIcon} alt="" />
          <span className="d-flex ms-1">Add New Offer</span>
        </div>
      </div>
      {/* Displaying Offers  */}
      <div className="mx-5 mb-3">
        <div className="row g-4">
          {offerData.length > 0 ? (
            offerData.map((offer) => (
              <>
                <div className="col-sm-12 col-md-6 col-xl-4">
                  <div
                    key={offer.id}
                    style={{ height: "420px", overflow: "auto" }}
                    className="d-flex flex-column align-items-center justify-content-center border border-1 rounded-4 offer_card px-2"
                  >
                    <p className=" fs-5 fw-bold">{offer.name}</p>
                    <div className="d-flex align-items-center">
                      <p style={{ textDecorationLine: "line-through" }}>
                        {offer.total_price}
                      </p>
                      <p className="mx-2">بدلا من</p>
                      <p>{offer.offer_price}</p>
                    </div>
                    <div className="mb-3 mianCategory_descrebtion">
                      {offer.description}
                    </div>
                    {offer.services
                      .filter((ser) => ser.selected === true)
                      .map((ser) => (
                        <div
                          className="d-flex justify-content-end align-items-center my-1 w-100"
                          key={ser.id}
                        >
                          <p className="my-0">{ser.name}</p>
                          <i className="fa-solid fa-circle fa-2xs text-muted mx-2 mt-1"></i>
                        </div>
                      ))}
                    <div className="d-flex justify-content-evenly w-50 edateTheOffercarde mx-auto">
                      <div
                        className="iconContuiner"
                        onClick={() =>
                          handleUpdateOffer(
                            offer.id,
                            offer.name,
                            offer.description
                          )
                        }
                      >
                        <img src={PenForEdit} alt="" />
                      </div>
                      <div
                        className="iconContuiner"
                        onClick={() => handleDeleteShow(offer.id)}
                      >
                        <img src={trash} alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ))
          ) : (
            <div className="noStaff-cards">
              <img
                className="noStaffImg"
                src={noDataFound}
                alt="No staff members"
              />
              <p className="noDataStaff-masege">
                No Offer have been added yet. Click add to new Offer.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
export default OffersPage;
